import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { modifyPermissionSettingsAction } from "@icarius-pages/permissionsSettings/actions";
import Loader from "@icarius-common/loader";
import { getLoading } from "../../selectors";
import useHandleForm from "../publication/useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const FilterDialog = (props) => {

  const {
    open,
    data,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);

  const modify = (dataToSend) => {
    dispatch(modifyPermissionSettingsAction(dataToSend))
      .then((res) => {
        if (res?.status === 200) {
          handleClose();
        }
      });
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, null, modify, openValidationError);

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      maxWidth={"md"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("filters")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        <Loader open={isLoading} />
        <Grid container item alignItems="center" xs={12} style={{ padding: 10 }}>
          <TextFieldMultiline
            fullWidth
            label={getLocalizedString("sqlFilterLabelPermissions")}
            helperText={getLocalizedString("sqlFilterHelperTextPermissions")}
            rows={10}
            margin={"none"}
            value={formData['sqlFilter']}
            onChange={(e) => setFormValue(e.target.value, "sqlFilter")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
        <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
      </DialogActions>
    </Dialog>
  );
}

export default FilterDialog;